import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldOff } from "lucide-react";

export const AccessDenied = () => {
  const navigate = useNavigate();
  return (
    <Card className="p-10 max-w-lg mx-auto mt-10 text-center space-y-3" data-testid="access-denied-page">
      <ShieldOff className="mx-auto text-primary" size={36} />
      <h1 className="font-heading text-xl font-bold text-navy">Akses Ditolak</h1>
      <p className="text-sm text-muted-foreground">Anda tidak memiliki izin untuk membuka halaman ini.</p>
      <Button className="bg-primary hover:bg-red-700" onClick={() => navigate("/")} data-testid="access-denied-home-btn">Kembali ke Dashboard</Button>
    </Card>
  );
};

export default function RoleRoute({ roles }) {
  const { user } = useAuth();
  if (!user || !roles.includes(user.role)) return <AccessDenied />;
  return <Outlet />;
}
